import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Alert, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../../../components/header';
import Footer from '../../../../components/footer';
import Head from '../../../../components/head';
import MetasFiscais from '../../../../components/contas/metasfiscais'


function ContasScreen() {
    return (
        <Fragment>
            <Head titulo="Metas Fiscais da Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/contas/audiencias'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <MetasFiscais />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ContasScreen;